import { render, staticRenderFns } from "./ReportBulkSubmitter.vue?vue&type=template&id=84612e1c&scoped=true&"
import script from "./ReportBulkSubmitter.vue?vue&type=script&lang=js&"
export * from "./ReportBulkSubmitter.vue?vue&type=script&lang=js&"
import style0 from "./ReportBulkSubmitter.vue?vue&type=style&index=0&id=84612e1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84612e1c",
  null
  
)

export default component.exports